import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";
import Footer from "../components/Footer";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Can I get approved for car financing with bad credit?",
      answer:
        "Yes! At Yes Auto, we specialize in helping people with all types of credit — including bad or no credit — get approved. Our approval rate is over 95%.",
    },
    {
      question: "How long does it take to get approved?",
      answer:
        "In most cases, approvals are processed within 24 hours. Once approved, you can choose from our 1500+ vehicles available for financing.",
    },
    {
      question: "Do I need to make a down payment?",
      answer:
        "A down payment is not always required. We work with flexible financing options to fit your budget and situation.",
    },
    {
      question: "Is Yes Auto available outside Alberta?",
      answer:
        "Currently, we serve customers across Alberta, Canada. Expansion to other provinces is in progress!",
    },
    {
      question: "Do you have your own cars or work with other dealers?",
      answer:
        "We own our own vehicles and also partner with trusted dealers. That’s what allows us to offer both the best rates and reliable quality.",
    },
  ];

  return (
    <div className="bg-white text-gray-800">
      {/* 🌟 Hero Section */}
      <section
  className="relative py-32 px-6 text-center text-white"
  style={{
    backgroundImage:
      "linear-gradient(rgba(10,37,69,0.6), rgba(13,94,99,0.6)), url('/fq.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-extrabold mb-4"
        >
          Frequently Asked Questions
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-gray-200 text-lg max-w-2xl mx-auto"
        >
          Find quick answers to the most common questions about Yes Auto’s car
          financing services.
        </motion.p>
      </section>

      {/* ❓ FAQ Section */}
      <section className="py-24 px-6 md:px-20 bg-gray-50 text-[#0a2545]">
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="mb-6 bg-white rounded-xl shadow-lg border border-teal-300/40 overflow-hidden"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center px-6 py-5 text-left text-lg font-semibold bg-gradient-to-r from-[#0a2545] to-[#0d5e63] text-white hover:opacity-90 transition"
              >
                {faq.question}
                <motion.span
                  animate={{ rotate: activeIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <FaChevronDown />
                </motion.span>
              </button>

              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    key="answer"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="px-6 py-4 bg-white text-gray-700"
                  >
                    {faq.answer}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </section>

     
      </div>
    
  );
};

export default FAQ;
